import React, { useContext, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import venomContext from "../../context/venomContext";
import Footer from "../footer/Footer";
import Header from "../header/Header";
// import { Buffer } from "buffer";
import Loader from "../loader/Loader";
import Banner from "../banner/Banner";

export default function Single() {
  const params = useParams();
  const context = useContext(venomContext);
  const { GetSpecificBlog, blogIDWise } = context;
  useEffect(() => {
    GetSpecificBlog(params.id);
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <Header />
      <Banner
        title={blogIDWise && blogIDWise.title}
        subtitle={blogIDWise && blogIDWise.category}
        textTransform={"uppercase"}
        is_single_blog={blogIDWise && blogIDWise}
        id={blogIDWise && blogIDWise._id}
      />
      <section className="single_blog">
        <div className="container">
          <div className="row">
            {!blogIDWise ||
            blogIDWise.length === 0 ||
            blogIDWise._id !== params.id ? (
              <Loader />
            ) : (
              [blogIDWise].map((curElem) => {
                const {
                  _id,
                  blog_feature_img,
                  createdAt,
                  description,
                  title,
                  author,
                  author_profile,
                } = curElem;
                var date = new Date(createdAt);
                let splitedDate = date.toString().split(" ");
                let month = splitedDate[1];
                let day = splitedDate[2];
                let year = splitedDate[3];
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? "pm" : "am";
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                hours = hours < 10 ? "0" + hours : hours;
                minutes = minutes < 10 ? "0" + minutes : minutes;
                var dateTime = month + ", " + day + " " + year;
                {
                  /* +
                  " at " +
                  hours +
                  ":" +
                  minutes +
                  " " +
                  ampm; */
                }
                return (
                  <div className="col-12" key={_id}>
                    <img
                      src={blog_feature_img && blog_feature_img}
                      alt=""
                      className="blog_img"
                    />
                    <div className="user d-flex align-items-center mt-5">
                      <div className="user-img">
                        <img src={author_profile} alt="" />
                      </div>
                      <div className="user-name">
                        <Link
                          to={
                            "/author/" + author.toLowerCase().replace(" ", "-")
                          }
                          className="m-0"
                        >
                          {author}
                        </Link>
                      </div>
                    </div>
                    <div className="date mt-2">
                      <p>{"Published at: " + dateTime}</p>
                    </div>
                    <h4 className="my-3">{title}</h4>
                    <div
                      className="blog_paragraph"
                      dangerouslySetInnerHTML={{ __html: description }}
                    ></div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
